"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var CookieConsentStore = (function () {
    function CookieConsentStore(cookieName, cookieAttributes) {
        this.cookieName = cookieName;
        this.cookieAttributes = cookieAttributes;
    }
    CookieConsentStore.prototype.accept = function () {
        this.setValue('1');
    };
    CookieConsentStore.prototype.refuse = function () {
        this.setValue('0');
    };
    CookieConsentStore.prototype.revoke = function () {
        js_cookie_1.default.remove(this.cookieName, this.cookieAttributes);
    };
    CookieConsentStore.prototype.hasBeenSet = function () {
        return typeof js_cookie_1.default.get(this.cookieName) !== 'undefined';
    };
    CookieConsentStore.prototype.isAccepted = function () {
        return js_cookie_1.default.get(this.cookieName) === '1';
    };
    CookieConsentStore.prototype.setValue = function (value) {
        js_cookie_1.default.set(this.cookieName, value, this.cookieAttributes);
    };
    return CookieConsentStore;
}());
exports.default = CookieConsentStore;
